import { useState } from "react";
import React from "react";

const web3FormsEndpoint = "https://api.web3forms.com/submit";

export const Contact = (props) => {
  const [sendStatus, setSendStatus] = useState("idle");
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

    if (!accessKey) {
      setSendStatus("error");
      setStatusMessage("The contact form is not configured yet. Please try again later.");
      return;
    }

    setSendStatus("sending");
    setStatusMessage("Sending your message…");

    const formData = new FormData(event.target);
    formData.append("access_key", accessKey);
    formData.append("subject", "New message from the Annwesha website");
    formData.append("from_name", "Annwesha website");

    try {
      const response = await fetch(web3FormsEndpoint, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Unable to send your message.");
      }

      event.target.reset();
      setSendStatus("success");
      setStatusMessage("Thank you — your message has been sent successfully.");
    } catch (error) {
      setSendStatus("error");
      setStatusMessage(error.message || "Message could not be sent. Please try again.");
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>Please fill out the form below to send us an email and we will get back to you as soon as possible.</p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit}>
                <input type="checkbox" name="botcheck" className="contact-botcheck" tabIndex="-1" autoComplete="off" />
                <div className="row">
                  <div className="col-md-6"><div className="form-group"><input type="text" id="name" name="name" className="form-control" placeholder="Name" required /></div></div>
                  <div className="col-md-6"><div className="form-group"><input type="email" id="email" name="email" className="form-control" placeholder="Email" required /></div></div>
                </div>
                <div className="col-md-6"><div className="form-group"><textarea name="message" id="message" className="form-control" rows="4" placeholder="Message" required /></div></div>

                {sendStatus !== "idle" && (
                  <div className={`contact-popup contact-popup--${sendStatus}`} role="status" aria-live="polite">
                    {sendStatus === "success" && <i className="fa fa-check-circle" aria-hidden="true" />}
                    {sendStatus === "error" && <i className="fa fa-exclamation-circle" aria-hidden="true" />}
                    {sendStatus === "sending" && <i className="fa fa-spinner fa-spin" aria-hidden="true" />}
                    {statusMessage}
                  </div>
                )}

                <div id="success" />
                <button type="submit" className="btn btn-custom btn-lg" disabled={sendStatus === "sending"}>
                  {sendStatus === "sending" ? "Sending…" : "Send Message"}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item"><h3>Contact Info</h3><p><span><i className="fa fa-map-marker" /> Address</span>{props.data ? props.data.address : "loading"}</p></div>
            <div className="contact-item"><p><span><i className="fa fa-phone" /> Phone</span>{props.data ? props.data.phone : "loading"}</p></div>
            <div className="contact-item"><p><span><i className="fa fa-envelope-o" /> Email</span>{props.data ? props.data.email : "loading"}</p></div>
          </div>
          <div className="col-md-12"><div className="row"><div className="social"><ul>
            <li><a href={props.data ? props.data.facebook : "/"}><i className="fa fa-facebook" /></a></li>
            <li><a href={props.data ? props.data.instagram : "/"}><i className="fa fa-instagram" /></a></li>
            <li><a href={props.data ? props.data.linkedin : "/"}><i className="fa fa-linkedin" /></a></li>
          </ul></div></div></div>
        </div>
      </div>
      <div id="footer"><div className="container text-center"><p>&copy; 2025 Department of Bengali, S. S. college, Hailakandi. All Rights Reserved (Last Updated on 11-09-2026)</p></div></div>
    </div>
  );
};
